export default __webpack_public_path__ + "static/aga-maciejowska-m-e219127b84a9817561f77cf39b7fae86.jpg";